module.exports = __webpack_public_path__ + "pic/54.11a3328c.png";